import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
// import store from './store'

import { IonicVue } from '@ionic/vue';

/* Core CSS required for Ionic components to work properly */
import '@ionic/vue/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/vue/css/normalize.css';
import '@ionic/vue/css/structure.css';
import '@ionic/vue/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/vue/css/padding.css';
import '@ionic/vue/css/float-elements.css';
import '@ionic/vue/css/text-alignment.css';
import '@ionic/vue/css/text-transformation.css';
import '@ionic/vue/css/flex-utils.css';
import '@ionic/vue/css/display.css';

/* Theme variables */
import './theme/variables.css';
import './theme/core.css';

import Toast from "vue-toastification";
// Import the CSS or use your own!
import "vue-toastification/dist/index.css";
import { createPinia } from 'pinia'



const options = {
  // You can set your default toast options here

  transition: "Vue-Toastification__fade",
  position: "bottom-center",
  timeout: 3000,
  closeOnClick: true,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  draggable: true,
  draggablePercent: 0.6,
  maxToasts: 4,
  // showCloseButtonOnHover: false,
  hideProgressBar: true,
  // closeButton: false,
  icon: false,
  rtl: false

};


import { initializeApp } from "firebase/app";
import { enableIndexedDbPersistence, getFirestore } from 'firebase/firestore';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries
// Your web app's Firebase configuration




const firebaseConfig = {
  apiKey: "AIzaSyBAAtkHHMnwPAfvQuqBXYX6obhPU8-Yf_I",
  authDomain: "birdiefy.firebaseapp.com",
  databaseURL: "https://birdiefy-default-rtdb.firebaseio.com",
  projectId: "birdiefy",
  storageBucket: "birdiefy.appspot.com",
  messagingSenderId: "920051178017",
  appId: "1:920051178017:web:68a8d9ecf1c000e987e160"
};
// Initialize Firebase
initializeApp(firebaseConfig);

const fdb = getFirestore();
enableIndexedDbPersistence(fdb)
  .catch((err) => {
      if (err.code == 'failed-precondition') {
          // Multiple tabs open, persistence can only be enabled
          // in one tab at a a time.
          // ...
      } else if (err.code == 'unimplemented') {
          // The current browser does not support all of the
          // features required to enable persistence
          // ...
      }
  });


const app = createApp(App)
// .use(store)
  .use(IonicVue)
  .use(Toast, options)
  app.use(createPinia())
  .use(router);

router.isReady().then(() => {
  app.mount('#app');
});

